<div class="row">
  <div *ngFor="let l of lists" class="col s12 m6">
    <list-card [config]="l"> </list-card>
  </div>
</div>
